import { render, staticRenderFns } from "./tableRow.vue?vue&type=template&id=1673faf7&scoped=true"
import script from "./tableRow.vue?vue&type=script&lang=js"
export * from "./tableRow.vue?vue&type=script&lang=js"
import style0 from "./tableRow.vue?vue&type=style&index=0&id=1673faf7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1673faf7",
  null
  
)

export default component.exports